import makeApi from "../../libs/axios/api";
import {
  DraftOrderPayload,
  type OrderDetailsList,
} from "../../types/draftOrder";
const apiPromise = makeApi();

const getDraftOrder = async (
  order: DraftOrderPayload
): Promise<OrderDetailsList> => {
  const api = await apiPromise;
  const params = new URLSearchParams({
    FromDate: order.FromDate || "",
    ToDate: order.ToDate || "",
    AccountNo: order.AccountNo || "",
    Status: order.Status?.toString() || "1",

    OrderByColumn: order.OrderByColumn || "",
    OrderBy: order.OrderBy || "",
    CountOnly: order.CountOnly?.toString() || "false",
    CompanyCode: order.CompanyCode || ""
  });

  const path = `/order/history?${params.toString()}`;

  return api.get(path).then((response) => {
    return response.data as OrderDetailsList;
  });
};

const deleteDraftOrder = async (orderId: number) => {
  const api = await apiPromise;
  const path = `/order/${orderId}`;

  const patchBody = {
    userName: "Automation",
    statusId: 25,
    isStatusUpdate: false,
    isDraftDelete: true,
  };

  return api
    .patch(path, patchBody)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Delete failed:", error);
      throw error;
    });
};

export { getDraftOrder, deleteDraftOrder };
